export default __webpack_public_path__ + "static/solution-api.url-4f693fc4a62d276a48d153c6b21496e1.svg";